export class PaymentFormData {
    constructor(
        public optIn?: boolean,
        public optInDate?: Date,
        public paymentType?: string,
        public kreditinstitut?: string,
        public kontoinhaber?: string,
        public optInFirstName?: string,
        public optInLastName?: string,
        public iban?: string,
        public ibanMandat?: boolean
    ) {}
}
